import React from 'react';
import PropTypes from 'prop-types';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { ordinal } from 'helpers/date_utils';

import BrokerLabel from './broker_label';
import BrokerSelect from './broker_select';
import { Button } from 'components/ui/button';
import { FormGroup } from 'react-bootstrap-5';

export default function BrokersList({
  brokers,
  isInvalid,
  disabled,
  maxBrokersLimit,
  required,
  onSetBrokers,
  primaryLabelPrefixIcon,
}) {
  const handleSetBroker = (newBroker, index) => {
    const newBrokers = [...brokers];
    newBrokers[index] = newBroker;

    onSetBrokers(newBrokers);
  };

  const handleOnNewBroker = () => {
    onSetBrokers([...brokers, {}]);
  };

  const removeBroker = (indexToRemove) => {
    onSetBrokers(brokers.filter((broker, index) => index !== indexToRemove));
  };

  const renderRow = (broker, index = 0) => {
    const label = `${index === 0 ? 'Primary' : ordinal(index + 1)} Broker`;
    const canDelete = index !== 0;

    return (
      <FormGroup className={`form-group ${required ? 'required' : ''}`} key={index}>
        <BrokerLabel
          label={label}
          prefixIcon={index === 0 ? primaryLabelPrefixIcon : null}
          required={required}
        />
        <div className="d-flex">
          <BrokerSelect
            broker={broker}
            disabled={disabled}
            isInvalid={isInvalid}
            onSetBroker={newBroker => handleSetBroker(newBroker, index)}
          />
          {canDelete && (
            <Button
              className="ms-2 text-destructive"
              icon={faCircleXmark}
              type="button"
              variant="ghost"
              onClick={() => removeBroker(index)}
            />
          )}
        </div>
      </FormGroup>
    );
  };

  return (
    <>
      {brokers.map((broker, index) => {
        return renderRow(broker, index);
      })}
      {brokers.length < maxBrokersLimit && (
        <span className="text-primary clickable" role="button" onClick={handleOnNewBroker}>+ Add another broker</span>
      )}
    </>
  );
}

BrokersList.propTypes = {
  brokers: PropTypes.array,
  disabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
  maxBrokersLimit: PropTypes.number.isRequired,
  primaryLabelPrefixIcon: PropTypes.node,
  required: PropTypes.bool,
  onSetBrokers: PropTypes.func.isRequired
};
